export const LABEL_TRANSLATION_MAP = {
  tariff_revenue: 'key.tariff_revenue',
  goods_revenue: 'key.goods_revenue',
  service_revenue: 'key.service_revenue',
} as const;

export const LABEL_ORDER: Record<keyof typeof LABEL_TRANSLATION_MAP, number> = {
  tariff_revenue: 1,
  goods_revenue: 2,
  service_revenue: 3,
};
